import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const StyledImage = ({
  image,
  objectFit,
  objectPosition,
  imagePosition,
  imgClassName,
  className,
  animated = false,
  ...rest
}) => {
  const alt = image?.altText
  return (
    <>
      {image?.localFile?.extension === "svg" || (image?.localFile?.extension === "pdf" && image?.mediaDetails?.sizes && image?.mediaDetails.sizes[0]?.sourceUrl) ? (
        <StandardImage
          image={image}
          objectFit={objectFit || image?.localFile?.extension === "svg" ? "contain" : "cover"}
          objectPosition={objectPosition}
          className={className}
          alt={alt}
          {...rest}
        />)
        : image ? (
          <GatsbyImage
            image={getImage(image?.localFile)}
            className={className}
            objectFit={objectFit}
            objectPosition={objectPosition}
            imgClassName={imgClassName}
            alt={alt || " "}
            {...rest}
          />
        ) : null}
    </>
  )
}

function StandardImage({ image, objectFit, objectPosition, className, alt }) {
  return (
    <img
      src={(image?.localFile?.extension === "pdf" && image?.mediaDetails?.sizes && image?.mediaDetails?.sizes[0]?.sourceUrl) ? image?.mediaDetails?.sizes[0]?.sourceUrl : image.localFile?.publicURL}
      className={`${className} ${objectFit === "contain"
        ? "object-contain"
        : objectFit === "cover"
          ? "object-cover"
          : ""
        }`}
      style={{ objectPosition: objectPosition }}
      alt={alt || ''}
      loading="lazy"
    />
  )
}

export default StyledImage
